/* global API_URL */

import fetch, { handleResponse, handleRequestFailure } from './fetch';

const getLiveStandings = async leagueSlug => {
  const liveStandings = await fetch(`${API_URL}/${leagueSlug}/live_standings`)
    .then(handleResponse)
    .catch(handleRequestFailure);

  return liveStandings.json;
};

export default getLiveStandings;
